import { useState } from "react";
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

import { createUser } from "../../../common/auth/service/authApi";
import { CreateUserDto } from "../../../common/auth/types/authTypes";
import { UserRoundPlus } from "lucide-react";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onSaved: () => void;
}

const CreateUserModal = ({
    isOpen,
    toggle,
    onSaved
}: Props) => {

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState<CreateUserDto>({
        name: "",
        email: "",
        password: "",
        phoneNumber: "",
        role: "Customer",
        gender: "Male"
    });

    const changeValue = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const { name, value } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const save = async () => {

        setLoading(true);

        try {

            await createUser(form);

            alert("User created successfully.");

            setForm({
                name: "",
                email: "",
                password: "",
                phoneNumber: "",
                role: "Customer",
                gender: "Male"
            });

            onSaved();

            toggle();

        }
        catch (error: any) {

            alert(
                error?.response?.data?.message ??
                "Failed to create user."
            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            size="md"
        >

              <div
    style={{
        borderRadius:"18px",
      overflow: "hidden",
      background: "#f8fafc",
    }}
  >

            <ModalHeader toggle={toggle}
      style={{
        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
        color: "#fff",
        padding: "18px 24px",
        fontWeight: 700,
         overflow: "hidden",
        fontSize: "22px",
      }}
            
            >
                <UserRoundPlus />  Create User
            </ModalHeader>

          <ModalBody>

    <Form className="fw-bold">

        <FormGroup floating className="mb-3 ">

            <Input
                id="name"
                name="name"
                placeholder="Name"
                value={form.name}
                onChange={changeValue}
            />

            <Label for="name" >
                Name
            </Label>

        </FormGroup>

        <FormGroup floating className="mb-3">

            <Input
                id="email"
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={changeValue}
            />

            <Label for="email">
                Email
            </Label>

        </FormGroup>

        <FormGroup floating className="mb-3">

            <Input
                id="password"
                type="password"
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={changeValue}
            />

            <Label for="password">
                Password
            </Label>

        </FormGroup>

        <FormGroup floating className="mb-3">

            <Input
                id="phoneNumber"
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={form.phoneNumber}
                onChange={changeValue}
            />

            <Label for="phoneNumber">
                Phone Number
            </Label>

        </FormGroup>

        <FormGroup className="mb-3">

            <Label for="gender">
                Gender
            </Label>

            <Input
                id="gender"
                type="select"
                name="gender"
                value={form.gender}
                onChange={changeValue}
            >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
            </Input>

        </FormGroup>

        <FormGroup>

            <Label for="role">
                Role
            </Label>

            <Input
                id="role"
                type="select"
                name="role"
                value={form.role}
                onChange={changeValue}
            >
                <option value="SuperAdmin">SuperAdmin</option>
                <option value="Admin">Admin</option>
                <option value="Coordinator">Coordinator</option>
                <option value="Customer">Customer</option>
            </Input>

        </FormGroup>

    </Form>

</ModalBody>

            <ModalFooter>

                <Button
                    color="secondary"
                    onClick={toggle}
                >
                    Cancel
                </Button>

                <Button
                    color="primary"
                    disabled={loading}
                    onClick={save}
                >
                  <UserRoundPlus />  {loading ? "Creating..." : "Create"}
                </Button>

            </ModalFooter>

            </div>

        </Modal>

    );

};

export default CreateUserModal;